module.exports = __webpack_public_path__ + "static/media/TheCollectiveBecome-Medium.2396748f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TheCollectiveBecome-Medium.woff
// module id = 732
// module chunks = 0